import { Texture, type NineSliceSprite } from 'pixi.js';
import type { NineSlicePlaneModel } from './types/models';
import { mapBlendMode } from './mapBlendMode';

export const copyNineSlicePlaneProps = (nineSliceSprite: NineSliceSprite, model: NineSlicePlaneModel): void => {
  nineSliceSprite.x = model.x;
  nineSliceSprite.y = model.y;
  nineSliceSprite.scale.x = model.scale.x;
  nineSliceSprite.scale.y = model.scale.y;
  nineSliceSprite.pivot.x = model.pivot.x;
  nineSliceSprite.pivot.y = model.pivot.y;
  nineSliceSprite.width = model.width;
  nineSliceSprite.height = model.height;
  nineSliceSprite.leftWidth = model.leftWidth;
  nineSliceSprite.topHeight = model.topHeight;
  nineSliceSprite.rightWidth = model.rightWidth;
  nineSliceSprite.bottomHeight = model.bottomHeight;
  nineSliceSprite.angle = model.angle;
  nineSliceSprite.alpha = model.alpha;
  nineSliceSprite.visible = model.visible;
  nineSliceSprite.tint = model.tint;
  nineSliceSprite.blendMode = mapBlendMode(model.blendMode);
  nineSliceSprite.interactive = model.interactive;
  nineSliceSprite.eventMode = model.buttonMode ? 'static' : 'auto';
  nineSliceSprite.cursor = model.buttonMode ? 'pointer' : 'default';
  nineSliceSprite.texture = Texture.from(model.texture);
};
